export interface UploadInvestorDocumentItem {
  docType: string;
  docCategory: string;
  side: string;
  fileName: string;
  fileType: string;
  url: string;
}

export interface UploadInvestorDocumentsPayload {
  documents: UploadInvestorDocumentItem[];
}

export interface InvestorDocumentDetail {
  docType: string;
  docCategory: string;
  side: string;
  fileName: string;
  fileType: string;
  verificationStatus: string;
  documentVerificationErrors: string[];
  thumbnail: string;
  createDate: string;
  documentId: string;
}

export interface UploadInvestorDocumentsResponse {
  data: InvestorDocumentDetail[];
}

export const UploadInvestorDocumentsResponseErrorCodes = {
  UNKNOWN_ERROR: "UNKNOWN_ERROR",
};

export type UploadInvestorDocumentsResponseErrorCode =
  (typeof UploadInvestorDocumentsResponseErrorCodes)[keyof typeof UploadInvestorDocumentsResponseErrorCodes];
